import { NOPING_GREEN } from '../constants';

export function GridGlow() {
  return (
    <div className='pointer-events-none absolute inset-0' aria-hidden='true'>
      <div className='absolute inset-0' style={{ background: `radial-gradient(ellipse at center, ${NOPING_GREEN}06 0%, transparent 70%)` }} />
    </div>
  );
}
